const SHOPIFY_CONFIG = {
  // Replace with your Shopify domain (without .myshopify.com)
  domain: 'd8bd9c-8a', // e.g., 'my-awesome-store'
  // Storefront Access Token (Public - safe for client-side)
  storefrontAccessToken: '84e85a29c65001ad437479eca3d63277', // Get from Apps > Manage private apps
  // API version
  apiVersion: '2025-01'
};